import { render, staticRenderFns } from "./CartFreight.vue?vue&type=template&id=cb182e2c"
import script from "./CartFreight.ts?vue&type=script&lang=ts&external"
export * from "./CartFreight.ts?vue&type=script&lang=ts&external"
import style0 from "./CartFreight.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports